import React, { useContext } from "react";
import "../App.css";
import "animate.css";
import ScrollAnimation from "react-animate-on-scroll";
// import Animate from 'animate.css-react';
import "animate.css/animate.compat.css"; // Import Animate.css styles

import abouthero from "../images/newabouthero.jpg";
import underaboutus from "../images/underaboutus.jpg";
import { Helmet } from "react-helmet-async";
import { SectionsContext } from "../store/section-context";
import logo from "../images/logo.png";

function About() {
  const iconClasses = [
    "fa-heart-circle-check",
    "fa-address-card",
    "fa-people-group",
    "fa-star",
    "fa-circle-check",
    "fa-hand-holding-heart",
    "fa-hands-helping",
    "fa-user-friends",
    "fa-user-check",
    "fa-heartbeat",
    "fa-user-shield",
    "fa-handshake",
    "fa-smile-beam",
    "fa-id-badge",
    "fa-users-cog",
    "fa-user-md",
    "fa-award",
    "fa-trophy",
    "fa-medal",
    "fa-thumbs-up",
  ];
  const { about } = useContext(SectionsContext);

  const { meta, hero, summary, mission, vision, value, whyChooseUs } = about;
  return (
    <div>
      <Helmet>
        {/* Title and Meta Description */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta
          property="og:url"
          content="https://www.brookshealthandcare.com/about"
        />
        <meta property="og:image" content={logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>
      {/* <div>
        <div>
          <img
            src={abouthero}
            className="d-block w-100  aboutheroimg"
            alt="An aged woman experiencing peace of mind."
          />
          <div className="carousel-caption mobile-carousel-caption d-block">
            <div className="lhs lhsmobile">
              <div className="lhsheading">
                {" "}
                <span className="thick-dot"></span>{" "}
                <span className="ps-1"> ABOUT BROOKS HEALTH AND CARE </span>{" "}
              </div>
              <div className="lhssubtitle pt-3">
                Caring for You Every Step of the Way{" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${hero.uri || abouthero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-doFt"></span>{" "}
            <span className="ps-1"> {hero.headline} </span>{" "}
          </div>
          <div className="lhssubtitle pb-2 pt-3">{hero.subheadline}</div>
        </div>
      </div>

      <div
        className="aboutsegment1  p-4 p-md-5"
        dangerouslySetInnerHTML={{ __html: summary }}
      ></div>
      <div className="greybg">
        <div
          className="aboutsegment2 p-4 p-md-5 "
          style={{
            backgroundImage: `url(${underaboutus})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            backgroundColor: "rgb(0 0 0 / 90%)",
          }}
        >
          <div className="missionbox">
            <div className="d-flex pt-5 ">
              <div className="homeSegment1aboutusline missionlinewhite"></div>
              <div className="homeSegment1aboutus missionwhite ps-2 ">
                {mission.heading}
              </div>
            </div>
            <div className="homeSegment3intro py-3">{mission.intro}</div>
            <div className="aboutsegment2desc py-2">
              <ul className="missionlist">
                {mission.list.map((mission, index) => (
                  <li key={index}>{mission}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="visionbox">
            <div className="d-flex pt-5 flexii  text-end">
              <div className="homeSegment1aboutusline missionlinewhite"></div>
              <div className="homeSegment1aboutus missionwhite ps-2 text-end">
                {vision.heading}
              </div>
            </div>
            <div className="homeSegment3intro homeSegment3introii py-3">
              {vision.intro}
            </div>
            <div className="aboutsegment2iidesc py-2">{vision.body}</div>
          </div>
        </div>
      </div>
      <div className="values p-md-5 p-4">
        <div className="valuesheading pb-md-5 pb-2">{value.heading}</div>
        <div>
          <div className="valuesdesc">{value.description}</div>

          <div>
            {value.items.map(({ subheading, description }, index) => (
              <div key={index}>
                <div className="valuesdesc pt-4">
                  <span className="valuessubheading">{subheading}</span>{" "}
                  {description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="aboutsegment3 p-4 p-md-5">
        <div className="d-flex pt-5 ">
          <div className="homeSegment1aboutusline"></div>
          <div className="homeSegment1aboutus ps-2 ">{whyChooseUs.heading}</div>
        </div>
        <div className="homeSegment3intro py-4">{whyChooseUs.intro}</div>
        <div className="aboutsegment3container">
          {whyChooseUs.items.map(({ title, description }, index) => (
            <ScrollAnimation
              key={index}
              className="aboutsegment3box"
              animateIn="bounceInUp"
              animationOut="fadeOut"
            >
              <div>
                <i
                  className={`aboutsegment3icon fa-solid ${
                    iconClasses[index % iconClasses.length]
                  }`}
                ></i>
              </div>
              <div className="aboutsegment3boxtitle py-3">{title}</div>
              <div className="aboutsegment3boxdesc">{description}</div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
      {/* <div className="aboutsegment4  p-4 p-md-5">
        <div className="d-flex pt-5 ">
          <div className="homeSegment1aboutusline"></div>
          <div className="homeSegment1aboutus ps-2 ">OUR DEDICATED TEAM </div>
        </div>
        <div className="homeSegment3intro py-4"> Company Structure</div>
        <div className="py-4">
          {" "}
          <img src={flowchart} alt="flowchart" className="flowchart" />{" "}
        </div>
      </div> */}
    </div>
  );
}
export default About;
